module.exports = __webpack_public_path__ + "static/media/zw.44f54d41.png";